import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box, Paper, ScopedCssBaseline, ThemeProvider, Typography,
} from '@mui/material';

import iziclaiMarque from '../../assets/iziclai_marque.png';
import { themeAssure } from '../../parcours/theme';

/**
 * La coquille commune aux écrans de compte : connexion, inscription,
 * mot de passe, activation.
 *
 * Ces quatre écrans avaient chacun leur mise en page, et ils divergeaient —
 * l'un citait les conditions, l'autre non ; l'un savait revenir en arrière,
 * l'autre laissait dans une impasse. Une seule coquille, et le contenu de
 * chaque page se réduit à son formulaire.
 */
export default function EcranAuth({ titre, sous_titre, children, bas }) {
  return (
    <ThemeProvider theme={themeAssure}>
      {/* Le CSS Bootstrap est importé globalement : cet écran s'en isole. */}
      <ScopedCssBaseline>
        <Box
          sx={{
            bgcolor: 'background.default',
            // La hauteur du header est déjà retirée du flux : centrer sur
            // 100vh laisserait une barre de défilement inutile.
            minHeight: 'calc(100vh - 68px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2,
            py: { xs: 4, md: 6 },
          }}
        >
          <Box sx={{ width: '100%', maxWidth: 440 }}>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Box component="img" src={iziclaiMarque} alt=""
                   sx={{ height: 56, width: 'auto', mb: 2 }} />
              <Typography variant="h1" sx={{ mb: sous_titre ? 0.5 : 0 }}>
                {titre}
              </Typography>
              {sous_titre && (
                <Typography variant="body2" color="text.secondary">
                  {sous_titre}
                </Typography>
              )}
            </Box>

            <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 } }}>
              {children}
            </Paper>

            {bas && (
              <Box sx={{ textAlign: 'center', mt: 3 }}>{bas}</Box>
            )}

            <Typography variant="caption" color="text.secondary"
                        component="div"
                        sx={{ textAlign: 'center', mt: 4, lineHeight: 1.6 }}>
              <Box component={Link} to="/conditions"
                   sx={{ color: 'inherit' }}>Conditions d'utilisation</Box>
              {' · '}
              <Box component={Link} to="/confidentialite"
                   sx={{ color: 'inherit' }}>Confidentialité</Box>
            </Typography>
          </Box>
        </Box>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}
